import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue';
  import Plotly from 'wrapper/plotly';
 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'cnt-plot_situation_amount',
  setup(__props) {

  const root = ref<HTMLElement | null>(null);
  
  onMounted(() => {
    const patienten = {
      x: [
        "0 bis unter 1",
        "1 bis unter 3",
        "3 bis unter 6",
        "6 bis unter 10",
        "10 bis unter 18",
      ],
      y: ['1726', '7587', '10694', '12190', '15311'],
      marker: { color: "#CBBE9E" },
      name: "chronisch erkrankt",
      type: "bar",
      textposition: "auto",
      hoverinfo: "y",
      text: ['']
    };
    const vorstellungen = {
      x: [
        "0 bis unter 1",
        "1 bis unter 3",
        "3 bis unter 6",
        "6 bis unter 10",
        "10 bis unter 18",
      ],
      y: ['16755', '44677', '37420', '24393', '22705'],
      marker: { color: "#E79E6B" },
      name: "nicht chronisch erkrankt",
      type: "bar",
      textposition: "auto",
      hoverinfo: "y",
      text: ['']
    };
    const layout = {
      barmode: "stack",
      title:
        "<b>Abb.2</b> <br>Vorstellungsanteil von Patienten<br> mit chronischer Grunderkrankung",
      yaxis: {
        hoverformat: ".1%",
        tickformat: ".0%",
      },
    };
    patienten.text = patienten.y.slice();
    vorstellungen.text = vorstellungen.y.slice();
    for (var i = 0; i < patienten.y.length; i++) {
      const pat = patienten.y[i];
      const vor = vorstellungen.y[i];
      patienten.y[i] = +pat / (+pat + (+vor)) + "%"; 
      vorstellungen.y[i] = +vor / (+pat + (+vor)) + "%";
    }
    patienten.y;
    Plotly.newPlot(root.value, [patienten, vorstellungen], layout, {
      modeBarButtonsToRemove: ["sendDataToCloud"],
    });
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "components__cnt-plot_situation_amount"
  }, null, 512))
}
}

})